<div class="loading-container">
  <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
  {{ loadingText }}
</div>
